import { Klass, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import "./klass.VuwSheet";

import nextStepCallBacks from "./assets/stepForm.nextStepCallBacks.default";
import aRequest from "./assets/stepForm.aRequest";
import activeSheet from "./assets/stepForm.activeSheet";
import aNextStep from "./assets/stepForm.aNextStep";

/**
 * VuwStepForm (extends VuwForm)
 * @options
 * - {String} activeSheetClassName
 * - {Boolean} enableAddExecModeParam: aNextStep時にmodeパラメータを付与するかどうか
 * - {String} execModeParamName: aNextStep時にmodeパラメータとして付与される値のname属性
 * - {Object} execModeValues: modeパラメータの値 confirm, exec, delを指定可能
 * - {String} confirmSheetName: 確認シートの名称（falseの場合は確認シートを生成しない）
 * - {String} finishSheetName: 完了シートの名称（falseの場合は完了シートを生成しない）
 * - {Object} nextStepCallBacks: コールバック集
 */
vuwer.appendKlass("VuwStepForm", {
	activeSheetClassName: "is-active",
	enableAddExecModeParam: true,
	execModeParamName: "mode",
	confirmSheetName: "confirm",
	finishSheetName: "finish",
	
	nextStepCallBacks,
	...aRequest,
	...activeSheet,
	...aNextStep,
	
	_initialize(opt) {
		this.execModeValues = { ...this.execModeValues };
		
		if( u_.isObject(opt) ) {
			if( u_.hasProperty(opt, "nextStepCallBacks")  ) {
				// nextStepCallBacksが指定されている場合
				if( u_.isObject(opt.nextStepCallBacks) ) {
					opt.nextStepCallBacks = {
						...this.nextStepCallBacks,
						...opt.nextStepCallBacks
					};
				} else {
					delete opt.nextStepCallBacks;
				}
			}
		}
		
		if( Klass("VuwStepForm").parent._initialize.call(this, opt) ) {
			this.resetMembers();
			
			this.onChangeState(state => {
				if( state.activeSheet instanceof Klass("VuwSheet") ) {
					this.$self.attr("data-active", state.activeSheet.name);
					
					if(state.activeSheet.$self) {
						return new Promise(resolve => {
							const duration = parseFloat(
								state.activeSheet.$self.css("transition-duration")
							);
							setTimeout(resolve, isNaN(duration) ? 100 : duration * 1000);
						});
					}
				}
			});
			
			return this;
		} else {
			return false;
		}
	},
	
	/**
	* メンバ変数初期化
	* */
	resetMembers() {
		this._sheets = [];
		this._sheets.map = {};
		this._activeSheetIdx = -1;
		return this;
	},
	
	/**
	* override add function
	* VuwSheetのインスタンスが追加された場合に_sheetsに追加する
	* */
	add(name) {
		Klass("VuwStepForm").parent.add.apply(this, arguments);
		const vuw = this.get(name);
		if( vuw && vuw instanceof Klass("VuwSheet") ) {
			this._sheets.push(vuw);
			this._sheets.map[vuw.name] = this._sheets.length - 1;
		}
		return this;
	},
	
	/**
	* シートの取得
	* 例）getSheet(".active") で現在アクティブなシートを取得する
	* @param {Integer | String} arg: インデックス or セレクタ
	* */
	getSheet(arg) {
		if( u_.isNumber(arg) ) {
			// 引数が数値の場合はインデックスとみなす
			return this._sheets[arg] || false;
		}
		if( u_.isString(arg) ) {
			// 引数が文字列の場合はVuw.nameとみなす
			return u_.isNumber(this._sheets.map[arg]) ? this._sheets[ this._sheets.map[arg] ] : false;
		}
		return this._sheets;
	}
}, "VuwForm");
